import { render, staticRenderFns } from "./documento.vue?vue&type=template&id=1cf0bb8c&"
import script from "./documento.vue?vue&type=script&lang=ts&"
export * from "./documento.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports